<template>
  <div>
    <div class="overlay" @click="$emit('closeCalendar')"></div>
    <div class="calendar">
      <CalendarHeader
        :month="month"
        :year="year"
        :date="date"
        @goPrev="goPrev"
        @goNext="goNext"
        @goPrevYear="goPrevYear"
        @goNextYear="goNextYear"
        @closeCalendar="$emit('closeCalendar')"
      ></CalendarHeader>

      <CalendarBody
        :currentDay="currentDay"
        :year="year"
        :month="month"
        @dayClick="dayClick"
      />
    </div>
  </div>
</template>

<script>
import CalendarBody from './calendarBody.vue'
import CalendarHeader from './calendarHeader.vue'
export default {
  name: 'Calendar',
  props: {
    currentDate: String,
  },
  data: () => ({
    date: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
    today: new Date(),
    currentDay: null,
  }),
  components: { CalendarHeader, CalendarBody },
  computed: {
    year() {
      return this.date.getFullYear()
    },
    month() {
      return this.date.getMonth()
    },
  },
  methods: {
    goNext() {
      let month = this.date.getMonth() + 1
      let newDate = new Date(new Date(this.date).setMonth(month))
      if (
        (this.today.getTime() - newDate.getTime()) / 1000 / 60 / 60 / 24 / 365 <
        18
      ) {
        return
      }
      this.date = new Date(this.date.setMonth(month))
    },
    goPrev() {
      let month = this.date.getMonth() - 1
      this.date = new Date(this.date.setMonth(month))
    },
    goNextYear() {
      let year = this.date.getFullYear() + 1
      let newDate = new Date(new Date(this.date).setYear(year))
      if (
        (this.today.getTime() - newDate.getTime()) / 1000 / 60 / 60 / 24 / 365 <
        18
      ) {
        return
      }
      this.date = new Date(this.date.setYear(year))
    },
    goPrevYear() {
      let year = this.date.getFullYear() - 1
      this.date = new Date(this.date.setYear(year))
    },
    async dayClick(day) {
      if (day) {
        this.currentDay = [day.date]
      } else {
        this.currentDay = null
      }
      this.$emit('dayClick', day)
    },
  },
  async mounted() {
    if (this.currentDate) {
      this.date = new Date(this.currentDate)
      this.currentDay = [new Date(this.currentDate).setHours(0)]
    }
  },
  created() {},
  watch: {},
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
.calendar {
  position: absolute;
  bottom: calc(100% + 30px);
  border: 1px solid color(green-main);
  left: 0;
  z-index: 1001;
  background-color: #fff;
  padding: 20px;
  max-width: 384px;
  min-height: 439px;
  margin: 0 auto;

  @media screen and (max-width: 374px) {
    max-width: 300px;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px;
  }
}
</style>
